module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share right"
  }, [_c('a', {
    staticClass: "share__icon share--toggle",
    style: ({
      backgroundColor: "#142D64"
    }),
    on: {
      "click": function($event) {
        _vm.toggleShare()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.isOpen ? _vm.getImgUrl('close_white') : _vm.getImgUrl('share-white'),
      "alt": _vm.isOpen ? '關閉' : '開啟'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "share__icon share__icon--list share--line",
    class: [_vm.isOpen ? 'open' : ''],
    attrs: {
      "id": "share-line",
      "target": "_blank",
      "href": "http://line.naver.jp/R/msg/text/?有一群原住民族以街頭為家，為了現行的傳統領域劃設辦法阻擋了回「家」的路，抗議了超過百天。明明去年總統已向原住民族道歉，還成立特別的委員會處理族群轉型正義的問題，他們到底在抗議什麼⋯⋯？%0D%0Ahttps://www.mirrormedia.mg/projects/20170801aboriginal/"
    },
    on: {
      "click": function($event) {
        _vm.shareLine()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/line_white_v2.png"),
      "alt": "Line"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "share__icon share__icon--list share--fb",
    class: [_vm.isOpen ? 'open' : ''],
    attrs: {
      "id": "share-fb",
      "target": "_blank",
      "href": "https://www.facebook.com/share.php?u=https://www.mirrormedia.mg/projects/20170801aboriginal/"
    },
    on: {
      "click": function($event) {
        _vm.shareFacebook()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook_white.png"),
      "alt": "Facebook"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "share__icon share__icon--list share--google",
    class: [_vm.isOpen ? 'open' : ''],
    attrs: {
      "id": "share-google",
      "target": "_blank",
      "href": "https://plus.google.com/share?url=https://www.mirrormedia.mg/projects/20170801aboriginal/"
    },
    on: {
      "click": function($event) {
        _vm.shareGooglePlus()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/google-plus.png"),
      "alt": "Google Plus"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eaebd30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 113
// module chunks = 1